import {apiClient} from "../apiClient";

export const TONG_HOP_SINH_VIEN_ENDPOINT = "tong-hop-sinh-vien";

export const tongHopSinhVienApi = {
    SelectLuyKe: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-luy-ke-by-sv/${id_sv}`
        ),
    SelectBienLaiLuyKe: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-bien-lai-luy-ke-by-sv/${id_sv}`
        ),
    SelectMucThuLuyKe: (id_sv: string) =>
        apiClient.get(
            `${TONG_HOP_SINH_VIEN_ENDPOINT}/select-muc-thu-luy-ke-by-sv/${id_sv}`
        ),
};
